module.exports = __webpack_public_path__ + "static/media/redStar.0e474cec.png";


//////////////////
// WEBPACK FOOTER
// ./src/img/redStar.png
// module id = 758
// module chunks = 0 1